
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 0C6.267 0 0 6.268 0 14s6.268 14 14 14c3.108 0 5.98-1.013 8.302-2.727l6.284 6.141a2 2 0 102.828-2.828l-6.263-6.121A13.939 13.939 0 0027.999 14c0-7.732-6.268-14-14-14zM4 14C4 8.477 8.477 4 14 4c5.522 0 10 4.477 10 10s-4.478 10-10 10C8.476 24 4 19.523 4 14z","fill":"currentColor"}})])
          )
        }
      }
    